
import { Tag } from "primereact/tag";

const MeaStudentStatus2 = ({ student, previousStatus = false, old = false }) => {
  let sStatus = previousStatus ? student?.previous_status : student?.status;
  return (
    <>
      {old && (<>
        {sStatus === "NEW" && (
          <Tag rounded value="Nouvelle candidature" severity="contrast" style={{ background: 'gray' }}></Tag>
        )}
        {sStatus === "PREREGISTRED" && (
          <Tag rounded value="Pré-inscription" severity="info" style={{ background: 'gray' }}></Tag>
        )}
        {sStatus === "ENROLLED" && (
          <Tag rounded value="Confirmée" severity="success" style={{ background: 'gray' }} ></Tag>
        )}
        {sStatus === "WAITING_LIST" && (
          <Tag rounded value="En liste d'attente" severity="warning" style={{ background: 'gray' }}></Tag>
        )}
        {sStatus === "UNREGISTRED" && (
          <Tag rounded value="Désinscription" severity="danger" style={{ background: 'gray' }}></Tag>
        )}

        {sStatus === "EXPELLED" && (
          <Tag rounded value="Exclu" severity="danger" style={{ background: 'gray' }}></Tag>
        )}
        {sStatus === "RETAINED" && (
          <Tag rounded value="Redoublé" severity="warning" style={{ background: 'gray' }}></Tag>
        )}
        {sStatus === "PASSED" && (
          <Tag rounded value="Réussi" severity="success" style={{ background: 'gray' }}></Tag>
        )}
      </>) || (<>
        {sStatus === "NEW" && (
          <Tag rounded value="Nouvelle candidature" severity="contrast"></Tag>
        )}
        {sStatus === "PREREGISTRED" && (
          <Tag rounded value="Pré-inscription" severity="info"></Tag>
        )}
        {sStatus === "ENROLLED" && (
          <Tag rounded value="Confirmée" severity="success" ></Tag>
        )}
        {sStatus === "WAITING_LIST" && (
          <Tag rounded value="En liste d'attente" severity="warning"></Tag>
        )}
        {sStatus === "UNREGISTRED" && (
          <Tag rounded value="Désinscription" severity="danger"></Tag>
        )}

        {sStatus === "EXPELLED" && (
          <Tag rounded value="Exclu" severity="danger"></Tag>
        )}
        {sStatus === "RETAINED" && (
          <Tag rounded value="Redoublé" severity="warning"></Tag>
        )}
        {sStatus === "PASSED" && (
          <Tag rounded value="Réussi" severity="success"></Tag>
        )}
      </>)}

    </>
  );
};
export default MeaStudentStatus2;
